<!--
  VLoading

  還原自 chunk-common.pretty.js L295。render function 已轉回 template。

  全螢幕半透明遮罩 + 置中的 loading 動畫，
  由 Checkout 在送出訂單、等待付款導向時顯示。
-->

<template>
  <div class="bg-overlay align-center d-flex jc-center fd-row p-flex t-0 r-0 b-0 l-0">
    <div class="pop-container d-flex p-flex a-center jc-center">
      <v-preloader />
    </div>
  </div>
</template>

<script>
import VPreloader from '@/components/VPreloader.vue'

export default {
  components: { 'v-preloader': VPreloader },
  data() {
    return {}
  },
  methods: {}
}
</script>
